import { imgAvatar } from "@/shared/assets/img";
import { ProgressRadial } from "@/shared/ui";

type Props = {
  name: string;
  id: number;
  level: number;
};

export default function PlayerMenuPlayerInfo({ name, id, level }: Props) {
  return (
    <div className="w-full flex items-center gap-3.5 px-10 mt-8">
      <img src={imgAvatar} alt="" className="h-[3rem] aspect-square shrink-0 rounded-[0.5rem]" />
      <div>
        <div className="text-12 font-bold uppercase">{name}</div>
        <div className="text-12 font-bold text-white/50 uppercase mt-1">ID: {id}</div>
      </div>

      <ProgressRadial percent={level} className="relative shrink-0 ml-auto" />
    </div>
  );
}
